import { toolTips } from '@/config';
import { getEnumText, getEnumValue } from '@/models/enum.utils';
import { colours } from '@/ux/colours';

export const CHANNELS = Object.freeze({
  INSTAGRAM: {
    value: 'INSTAGRAM',
    text: 'Instagram',
    chartLegend: 'Instagram',
    ugcChannel: 'INSTAGRAM_UGC',
    channelIcon: 'instagram',
    channelMonoIcon: 'instagram-mono',
    chartColor: colours.CHART_SOCIAL_CHANNEL.CHART_SC_INSTAGRAM,
    typeOverride: {
      CONTENT_OWNED_STORIES: 'CONTENT_OWNED',
    },
  },
  INSTAGRAM_STORIES: {
    value: 'INSTAGRAM_STORIES',
    text: 'Instagram Stories',
    chartLegend: 'Instagram Stories',
    channelIcon: 'instagramStories',
    dashingUiChannel: 'INSTAGRAM_STORY',
    dashingUiChannelIcon: 'instagram story',
    tooltip: 'Instagram Story',
    chartColor: colours.CHART_SOCIAL_CHANNEL.CHART_SC_IG_STORIES,
    typeOverride: {
      CONTENT_OWNED: 'CONTENT_OWNED_STORIES',
    },
  },
  INSTAGRAM_UGC: {
    value: 'INSTAGRAM_UGC',
    text: 'Instagram',
    chartLegend: 'Instagram UGC',
    channelIcon: 'instagram',
    chartColor: colours.CHART_SOCIAL_CHANNEL.CHART_SC_IG_UGC,
    hideFromChannelList: true,
  },
  INSTAGRAM_STORIES_UGC: {
    value: 'INSTAGRAM_STORIES_UGC',
    text: 'Instagram Stories',
    chartLegend: 'Instagram Stories UGC',
    channelIcon: 'instagramStories',
    chartColor: colours.CHART_SOCIAL_CHANNEL.CHART_SC_IG_STORIES,
    dashingUiChannelIcon: 'instagram story',
    hideFromChannelList: true,
  },
  INSTAGRAM_COMPETITIVE: {
    value: 'INSTAGRAM_COMPETITIVE',
    competitiveChannelType: 'INSTAGRAM',
    text: 'Instagram',
    channelIcon: 'instagram',
    chartColor: colours.CHART.WILDCARD,
    hideFromChannelList: true,
  },
  INSTAGRAM_BENCHMARKS: {
    value: 'INSTAGRAM_BENCHMARKS',
    text: 'Instagram',
    channelIcon: 'instagram',
    chartColor: '',
    hideFromChannelList: true,
  },
  INSTAGRAM_CREATORS: {
    value: 'INSTAGRAM_CREATORS',
    text: 'Instagram Creators',
    channelIcon: 'instagram',
    chartColor: colours.CHART.SET.CHART_SET_23,
    hideFromChannelList: true,
    hideFromCompetitiveChannelList: true,
  },
  TIKTOK: {
    value: 'TIKTOK',
    text: 'TikTok',
    chartLegend: 'TikTok',
    channelIcon: 'tiktok',
    channelMonoIcon: 'tiktok-mono',
    tooltip: 'Tik Tok',
    chartColor: colours.CHART_SOCIAL_CHANNEL.CHART_SC_TIKTOK,
    typeOverride: {
      CONTENT_OWNED_STORIES: 'CONTENT_OWNED',
    },
  },
  TIKTOK_ADS: {
    value: 'TIKTOK_ADS',
    text: 'TikTok Ads',
    channelIcon: 'tiktok',
    hideFromChannelList: true,
  },
  TIKTOK_UGC: {
    value: 'TIKTOK_UGC',
    text: 'TikTok',
    chartLegend: 'TikTok UGC',
    channelIcon: 'tiktok',
    chartColor: colours.CHART_SOCIAL_CHANNEL.CHART_SC_TIKTOK,
    hideFromChannelList: true,
    hideFromCompetitiveChannelList: true,
  },
  TIKTOK_CREATORS: {
    value: 'TIKTOK_CREATORS',
    text: 'TikTok Creators',
    channelIcon: 'tiktok',
    chartColor: colours.CHART.SET.CHART_SET_24,
    hideFromChannelList: true,
    hideFromCompetitiveChannelList: true,
  },
  FACEBOOK: {
    value: 'FACEBOOK',
    text: 'Facebook',
    chartLegend: 'Facebook',
    channelIcon: 'facebook',
    chartColor: colours.CHART_SOCIAL_CHANNEL.CHART_SC_FACEBOOK,
    typeOverride: {
      CONTENT_OWNED_STORIES: 'CONTENT_OWNED',
    },
  },
  FACEBOOK_COMPETITIVE: {
    value: 'FACEBOOK_COMPETITIVE',
    competitiveChannelType: 'FACEBOOK',
    text: 'Facebook',
    channelIcon: 'facebook',
    chartColor: colours.CHART.WILDCARD,
    hideFromChannelList: true,
  },
  META_ADS: {
    value: 'META_ADS',
    text: 'Meta Ads',
    channelIcon: 'meta',
    chartColor: colours.CHART_SOCIAL_CHANNEL.CHART_SC_META_ADS,
    hideFromChannelList: true,
  },
  MESSENGER: {
    value: 'MESSENGER',
    text: 'Messenger',
    channelIcon: 'messenger',
    hideFromChannelList: true,
  },
  AUDIENCE_NETWORK: {
    value: 'AUDIENCE_NETWORK',
    text: 'Meta Audience Network',
    channelIcon: 'audience_network',
    hideFromChannelList: true,
  },
  PINTEREST: {
    value: 'PINTEREST',
    text: 'Pinterest',
    chartLegend: 'Pinterest',
    channelIcon: 'pinterest',
    chartColor: colours.CHART_SOCIAL_CHANNEL.CHART_SC_PINTEREST,
    typeOverride: {
      CONTENT_OWNED_STORIES: 'CONTENT_OWNED',
    },
  },
  YOUTUBE: {
    value: 'YOUTUBE',
    text: 'YouTube',
    chartLegend: 'YouTube',
    channelIcon: 'youtube',
    channelMonoIcon: 'youtube-mono',
    tooltip: 'YouTube',
    chartColor: colours.CHART_SOCIAL_CHANNEL.CHART_SC_YOUTUBE,
  },
  YOUTUBE_COMPETITIVE: {
    value: 'YOUTUBE_COMPETITIVE',
    competitiveChannelType: 'YOUTUBE',
    text: 'YouTube',
    channelIcon: 'youtube',
    chartColor: colours.CHART.WILDCARD,
    hideFromChannelList: true,
  },
  LINKEDIN: {
    value: 'LINKEDIN',
    text: 'LinkedIn',
    chartLegend: 'LinkedIn',
    channelIcon: 'linkedin',
    channelMonoIcon: 'linkedin-mono',
    chartColor: colours.CHART_SOCIAL_CHANNEL.CHART_SC_LINKEDIN,
  },
  THREADS: {
    value: 'THREADS',
    text: 'Threads',
    chartLegend: 'Threads',
    channelIcon: 'threads',
    chartColor: colours.CHART_SOCIAL_CHANNEL.CHART_SC_THREADS,
  },
  TWITTER: {
    value: 'TWITTER',
    text: 'X',
    chartLegend: 'X',
    channelIcon: 'twitter',
    channelMonoIcon: 'x-mono',
    chartColor: colours.CHART_SOCIAL_CHANNEL.CHART_SC_TWITTER,
    typeOverride: {
      CONTENT_OWNED_STORIES: 'CONTENT_OWNED',
    },
  },
  TWITTER_COMPETITIVE: {
    value: 'TWITTER_COMPETITIVE',
    text: 'X',
    competitiveChannelType: 'TWITTER',
    channelIcon: 'twitter',
    chartColor: colours.CHART.WILDCARD,
    hideFromChannelList: true,
  },
  WEB: {
    value: 'WEB',
    text: 'Web',
    channelIcon: 'web',
    hideFromChannelList: true,
  },
  REDDIT: {
    value: 'REDDIT',
    text: 'Reddit',
    chartLegend: 'Reddit',
    channelIcon: 'reddit',
    channelMonoIcon: 'reddit-mono',
    hideFromChannelList: true,
  },
  SNAPCHAT: {
    value: 'SNAPCHAT',
    text: 'Snapchat',
    chartLegend: 'Snapchat',
    channelIcon: 'snapchat',
    channelMonoIcon: 'snapchat',
    dashingUiChannelIcon: 'snapchat',
    chartColor: colours.CHART_SOCIAL_CHANNEL.CHART_SC_SNAPCHAT,
    mediaTypes: {
      SNAP: 'Snap',
      SPOTLIGHT: 'Spotlight',
      STORY: 'Story',
      SAVED_STORY: 'Saved Story',
    },
    hideFromChannelList: true,
  },
  TSI_CHANNELS: {
    value: 'TSI_CHANNELS',
    text: 'TSI_CHANNELS',
    hideFromChannelList: true,
  },
  UNKNOWN: {
    value: 'UNKNOWN',
    text: 'Unknown',
    channelIcon: 'meta',
    hideFromChannelList: true,
  },
});

export const ALL_CHANNELS_KEY = 'ALL_CHANNELS';
export const MULTI_CHANNEL_KEY = 'MULTI_CHANNEL';
export const MULTI_CHANNEL_CONTENT_KEY = 'MULTI_CHANNEL_CONTENT';

export const DASHBOARD_OWNED_CHANNELS = [
  CHANNELS.FACEBOOK.value,
  CHANNELS.INSTAGRAM.value,
  CHANNELS.INSTAGRAM_STORIES.value,
  CHANNELS.LINKEDIN.value,
  CHANNELS.PINTEREST.value,
  CHANNELS.TIKTOK.value,
  CHANNELS.TWITTER.value,
  CHANNELS.YOUTUBE.value,
];

export const COMPETITIVE_CHANNELS = [
  CHANNELS.INSTAGRAM_COMPETITIVE.value,
  CHANNELS.TWITTER_COMPETITIVE.value,
  CHANNELS.YOUTUBE_COMPETITIVE.value,
  CHANNELS.FACEBOOK_COMPETITIVE.value,
];
export const MEDIA_TYPE_CHANNELS = [
  CHANNELS.INSTAGRAM.value,
  CHANNELS.INSTAGRAM_BENCHMARKS.value,
  CHANNELS.INSTAGRAM_COMPETITIVE.value,
  CHANNELS.FACEBOOK.value,
  CHANNELS.FACEBOOK_COMPETITIVE.value,
];
export const ENTERTAINMENT_SCORE_CHANNELS = [CHANNELS.INSTAGRAM.value, CHANNELS.TIKTOK.value];
export const META_ADS_CHANNELS = [CHANNELS.INSTAGRAM.value, CHANNELS.FACEBOOK.value];
export const ADS_CHANNELS = [CHANNELS.TIKTOK_ADS.value, CHANNELS.META_ADS.value];
export const INDUSTRY_CHANNELS = [CHANNELS.INSTAGRAM_BENCHMARKS.value];

export const FRONTEND_TO_BACKEND_CHANNEL_MAP = {
  INSTAGRAM_STORY: CHANNELS.INSTAGRAM_STORIES.value,
};

export const EARNED_CHANNELS = [
  CHANNELS.INSTAGRAM_UGC.value,
  CHANNELS.INSTAGRAM_STORIES_UGC.value,
  CHANNELS.TIKTOK_UGC.value,
];

export const COMMUNITY_CHANNELS = [
  CHANNELS.INSTAGRAM.value,
  CHANNELS.TIKTOK.value,
  CHANNELS.FACEBOOK.value,
  CHANNELS.TWITTER.value,
  CHANNELS.YOUTUBE.value,
];

export const TSI_ENABLED_CHANNELS = [
  CHANNELS.INSTAGRAM.value,
  CHANNELS.INSTAGRAM_STORIES.value,
  CHANNELS.INSTAGRAM_UGC.value,
  CHANNELS.TIKTOK.value,
  CHANNELS.TIKTOK_UGC.value,
  CHANNELS.FACEBOOK.value,
  CHANNELS.PINTEREST.value,
  CHANNELS.YOUTUBE.value,
  CHANNELS.LINKEDIN.value,
  CHANNELS.TWITTER.value,
];

/**
 * @param {string[]} channels
 * @returns {string[]}
 */
export const excludeYouTube = (channels) =>
  channels.filter((channel) => channel !== CHANNELS.YOUTUBE.value);

export const getTsiEnabledChannels = (youTubeAllowed = true) =>
  youTubeAllowed ? [...TSI_ENABLED_CHANNELS] : excludeYouTube(TSI_ENABLED_CHANNELS);

export const SOCIAL_LISTENING_CHANNELS = [
  CHANNELS.INSTAGRAM.value,
  CHANNELS.TIKTOK.value,
  CHANNELS.FACEBOOK.value,
  CHANNELS.YOUTUBE.value,
  CHANNELS.LINKEDIN.value,
  CHANNELS.TWITTER.value,
  CHANNELS.WEB.value,
  CHANNELS.REDDIT.value,
];

// A base UGC channel is used for earned channels because they share the same UGC permission
export const BASE_UGC_CHANNEL = CHANNELS.INSTAGRAM_UGC.value;

// `media.source` values that don't map 1:1 to `CHANNELS.X.value`. Anything not
// listed here (e.g. INSTAGRAM, TIKTOK, LINKEDIN) is identical to its channel value.
export const SOURCE_TO_CHANNEL = Object.freeze({
  FACEBOOK_LINK: CHANNELS.FACEBOOK.value,
  FACEBOOK_TEXT: CHANNELS.FACEBOOK.value,
  FACEBOOK_TEXT_LINK: CHANNELS.FACEBOOK.value,
  FACEBOOK_OTHER: CHANNELS.FACEBOOK_COMPETITIVE.value,
  FACEBOOK_OTHER_TEXT: CHANNELS.FACEBOOK_COMPETITIVE.value,
  FACEBOOK_OTHER_LINK: CHANNELS.FACEBOOK_COMPETITIVE.value,
  FACEBOOK_OTHER_TL: CHANNELS.FACEBOOK_COMPETITIVE.value,
  TWITTER_LINK: CHANNELS.TWITTER.value,
  TWITTER_TEXT: CHANNELS.TWITTER.value,
  INSTAGRAM_STORY: CHANNELS.INSTAGRAM_STORIES.value,
});

export function getChannelFromSource(source) {
  if (!source) return null;
  return SOURCE_TO_CHANNEL[source] ?? source;
}

export function isUGCMetric(metric) {
  return typeof metric === 'string' && metric.startsWith('UGC_');
}

export function isEarnedChannel(channel) {
  return EARNED_CHANNELS.includes(channel);
}

export const BYPASS_CHANNEL_PERMISSION_CHECK_LIST = [CHANNELS.WEB.value, CHANNELS.REDDIT.value];

export const getChannelConfigProp = (channel, property) => {
  const channelKey = getEnumValue(channel);
  const channelConfig = CHANNELS[channelKey];
  return channelConfig?.[property];
};

export const getChannelTypeOverride = (channel, type) =>
  CHANNELS?.[channel]?.typeOverride?.[type] || type;

export function getChannelText(channel) {
  const channelText = getChannelConfigProp(channel, 'text');
  return channelText || getEnumText(channel);
}

export function compareChannels(left, right) {
  const channels = Object.keys(CHANNELS);
  return channels.indexOf(left) - channels.indexOf(right);
}

export function filterNonCompetitiveChannels() {
  return (channel) => getChannelConfigProp(channel, 'competitiveChannelType');
}

export function filterChannelIfUnknown() {
  return (channel) => !!CHANNELS?.[channel];
}

export function filterOutNonSelectableChannels() {
  return (channel) => !getChannelConfigProp(channel, 'hideFromChannelList');
}

export function filterOutNonSelectableCompetitiveChannels() {
  return (channel) => !getChannelConfigProp(channel, 'hideFromCompetitiveChannelList');
}

export function getAccountDisconnectionMessage(channel) {
  return toolTips.accountDisconnection?.[channel?.toLowerCase()] || '';
}
